import { useNavigate } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import Hero from "../components/Hero";
import Testimonials from "../components/Testimonials";
import Carriers from "../components/Carriers";
import FeatureSections from "../components/FeatureSections";
import Receipts from "../components/Receipts";
import Faq from "../components/Faq";
import Founder from "../components/Founder";
import Footer from "../components/Footer";

export default function LandingPage() {
  const navigate = useNavigate();
  const goQuiz = () => navigate("/apply");
  const pageRef = useRef(null);
  const { scrollYProgress } = useScroll();
  const bgY = useTransform(scrollYProgress, [0, 1], ["0%", "12%"]);

  return (
    <div ref={pageRef} className="relative min-h-screen bg-[#030712] text-white noise-overlay" data-testid="landing-page">
      <motion.div
        aria-hidden="true"
        className="pointer-events-none fixed inset-0 z-0"
        style={{
          y: bgY,
          background:
            "radial-gradient(60% 40% at 50% 0%, rgba(0,198,239,0.09), transparent 70%), radial-gradient(40% 30% at 85% 45%, rgba(37,99,235,0.08), transparent 70%), radial-gradient(35% 30% at 12% 75%, rgba(0,198,239,0.06), transparent 70%)",
        }}
      />
      <main className="relative z-10">
        <Hero onStartQuiz={goQuiz} />
        <Testimonials />
        <Carriers />
        <FeatureSections />
        <Receipts />
        <Faq />
        <Founder onStartQuiz={goQuiz} />
        <Footer />
      </main>
    </div>
  );
}
